module.exports = __webpack_public_path__ + "img/milkcow.796c2291.svg";